<template>
<div>

  <vx-card :title="this.company.name" class="mt-4">
    <company-form :companyForm="company" :readonly="!isAuthorized('COMPANY_ADD')" :tenantType:="getTenantType()"></company-form>
  </vx-card>

  <vx-card class="mt-3" title="Relatórios de Crédito">
    <vs-row class="mt-3">
      <vs-col>
        <vs-button @click="openPrompt()">Gerar Novo Relatório</vs-button>
      </vs-col>
    </vs-row>

    <vs-row class="mt-3">
      <vs-col>
        <vs-table stripe class="w-full" :data="creditReports" noDataText="Nenhum relatório de crédito cadastrado.">
          <template slot="thead">
            <th>Data</th>
            <th>Score</th>
            <th>Status</th>
            <th>Criado Por</th>
            <th>Data de Criação</th>
            <th></th>
          </template>

          <template v-slot="{data}">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <td>
                {{row.createdAt | formatDate}}
              </td>
              <td>
                {{row.score}}
              </td>
              <td>
                {{row.status | formatCreditReportStatus}}
              </td>
              <td>
                {{row.createdBy.email}}
              </td>
              <td>
                {{row.createdAt | formatDateTime}}
              </td>
              <td>
                <a v-if="row.status === 'DONE'" role="button" style="cursor: pointer" @click="downloadReport(row.guid)">Download</a>
              </td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
  </vx-card>

  <vx-card title="Balanços" class="mt-4">

    <vs-row>
      <vs-col>
        <vs-button @click="openBalancePrompt()">Cadastrar Balanço Patrimonial</vs-button>
      </vs-col>
    </vs-row>

    <vs-row class="mt-6">
      <vs-table stripe :data="balanceTable" class="w-full" noDataText="Não há balanços cadastrados">

        <template slot="thead">

        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(row, indextr) in data">
            <vs-td :key="idx" v-for="(item, idx) in row">
              <template v-if="idx === 0">
                <p class="font-semibold">{{item}}</p>
              </template>
              <template v-else>
                <span v-if="indextr === 0" class="font-bold">{{item | formatDate}}</span>
                <span v-else>{{item | toDecimal}}</span>
              </template>
            </vs-td>
          </vs-tr>
        </template>

      </vs-table>
    </vs-row>

  </vx-card>

  <vx-card title="Memória de Cálculo do ScoreCard" class="mt-4">
    <vs-row>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-align="center">
        <vs-row>
          <vs-col vs-lg="3" vs-sm="6" vs-xs="12" vs-align="center" class="mt-4">
            <label>Data do balanço</label>
            <vs-select
              v-model="selectedBalance"
              autocomplete
              class="w-full">
              <vs-select-item :key="index" :value="item" :text="item.date" v-for="(item, index) in balances" class="w-full"/>
            </vs-select>
          </vs-col>

          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" class="mt-10">
            <vs-button @click="rating(selectedBalance)" vs-type="line" class="mr-3">Calcular Rating</vs-button>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-lg="9" vs-sm="6" vs-xs="12" vs-align="center">
        <vue-json-pretty
          theme="dark"
          showLineNumber="true"
          showIcon="true"
          v-if="ratingResponse.data != null"
          :data="ratingResponse.data"
          class="vue-json-scrollable"/>
        <vue-json-pretty
          v-if="ratingResponse.message != null"
          :data="ratingResponse.message"
          class="vue-json-scrollable"/>
      </vs-col>
    </vs-row>
  </vx-card>

  <!-- Prompt createCreditReport -->
  <vs-prompt
    @accept="createCreditReport()"
    title="Novo relatório de crédito"
    accept-text="Criar Relatório"
    cancel-text="Cancelar"
    :active.sync="creditReportPrompt">
    <div>
      <!-- Arquivo de divulgação de resultados (obrigatório) -->
      <div class="vx-row">
        <div class="vx-col">
          <p>Arquivo de divulgação de resultados <strong>(obrigatório)</strong></p>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col">
          <label class="file-select">
            <div class="select-button">
              <span class="vs-component vs-button vs-button-primary vs-button-filled">Escolher Arquivo PDF</span>
            </div>
            <input
              type="file"
              id="file"
              ref="file"
              accept=".pdf"
              v-on:change="handleFileUpload"
            />
          </label>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col">
          <div v-if="file">
            <span v-if="fileIsValid" class="text-success">
              <i class="material-icons">check_circle</i>
              {{ file.name }} pronto para upload.
            </span>
            <span v-else class="text-danger">
              <i class="material-icons">error</i>
              Arquivo inválido. Por favor, envie um arquivo PDF.
            </span>
          </div>
        </div>
      </div>

      <!-- Arquivo de informações cadastrais (opcional) -->
      <div class="vx-row mt-6">
        <div class="vx-col">
          <p>Informações cadastrais <span class="text-grey">(opcional)</span></p>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col">
          <label class="file-select">
            <div class="select-button">
              <span class="vs-component vs-button vs-button-primary vs-button-filled">Escolher Arquivo TXT</span>
            </div>
            <input
              type="file"
              id="registration-file"
              ref="registrationFile"
              accept=".txt"
              v-on:change="handleRegistrationFileUpload"
            />
          </label>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col">
          <div v-if="registrationFile">
            <span v-if="registrationFileIsValid" class="text-success">
              <i class="material-icons">check_circle</i>
              {{ registrationFile.name }}
            </span>
            <span v-else class="text-danger">
              <i class="material-icons">error</i>
              Arquivo inválido. Por favor, envie um arquivo TXT.
            </span>
          </div>
        </div>
      </div>

      <!-- Arquivo de empresas coligadas (opcional) -->
      <div class="vx-row mt-6">
        <div class="vx-col">
          <p>Informações de empresas coligadas <span class="text-grey">(opcional)</span></p>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col">
          <label class="file-select">
            <div class="select-button">
              <span class="vs-component vs-button vs-button-primary vs-button-filled">Escolher Arquivo TXT</span>
            </div>
            <input
              type="file"
              id="affiliated-companies-file"
              ref="affiliatedCompaniesFile"
              accept=".txt"
              v-on:change="handleAffiliatedCompaniesFileUpload"
            />
          </label>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col">
          <div v-if="affiliatedCompaniesFile">
            <span v-if="affiliatedCompaniesFileIsValid" class="text-success">
              <i class="material-icons">check_circle</i>
              {{ affiliatedCompaniesFile.name }}
            </span>
            <span v-else class="text-danger">
              <i class="material-icons">error</i>
              Arquivo inválido. Por favor, envie um arquivo TXT.
            </span>
          </div>
        </div>
      </div>
    </div>
  </vs-prompt>

  <!-- Prompt balanceUpload -->
  <vs-prompt
    @accept="balanceUpload"
    title="Balanço Patrimonial"
    accept-text="Upload"
    cancel-text="Cancelar"
    :active.sync="balanceUploadPrompt">
    <div>
      <div class="vx-row">
        <div class="vx-col">
          <p>Faça o upload do balanço patrimonial em formato <strong>XLSX</strong>.</p>
          <p class="text-muted">Certifique-se de que o arquivo segue o modelo exigido.</p>
        </div>
      </div>
      <div class="vx-row mt-6">
        <div class="vx-col">
          <vs-checkbox v-model="overwrite">Sobrescrever balanço existente?</vs-checkbox>
        </div>
      </div>
      <div class="vx-row mt-6">
        <div class="vx-col">
          <label class="file-select">
            <div class="select-button ml-2">
              <span class="vs-component vs-button vs-button-primary vs-button-filled">
                Escolher Arquivo
              </span>
            </div>
            <input
              type="file"
              id="file-balance"
              ref="file-balance"
              accept=".xlsx, .xlsm"
              v-on:change="handleBalanceFileUpload"
              style="display: none;"
            />
          </label>
        </div>
      </div>
      <div class="vx-row mt-6">
        <div class="vx-col">
          <!-- Feedback do arquivo -->
          <div v-if="balanceFile">
            <span v-if="balanceFileIsValid" class="text-success">
              <i class="material-icons">check_circle</i>
              {{ balanceFile.name }} pronto para upload.
            </span>
            <span v-else class="text-danger">
              <i class="material-icons">error</i>
              Arquivo inválido. Por favor, envie um arquivo XLSX.
            </span>
          </div>
        </div>
      </div>
    </div>
  </vs-prompt>

</div>
</template>
<script>
import axios from 'axios'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import CompanyForm from "@/components/CompanyForm";
import UserAuthorization from "@/mixins/UserAuthorization";

export default {
  name: 'BalancoEmpresa',
  mixins:[UserAuthorization],
  props: {
    guid: String
  },
  components: {
    VueJsonPretty,
    CompanyForm
  },
  data() {
    return {
      overwrite: false,
      creditReports: [],
      selectedBalance: {
        date: null,
        guid: null,
      },
      balanceTable: [],
      balances: [],
      company: {
        profile: [],
      },
      sector: {
        code: null,
        name: null
      },
      sectors: [],
      proposes: [
        {
          files: []
        }
      ],
      file: '',
      balanceFile: '',
      registrationFile: '',
      affiliatedCompaniesFile: '',
      fileIsValid: false,
      balanceFileIsValid: false,
      registrationFileIsValid: false,
      affiliatedCompaniesFileIsValid: false,
      showUpload: false,
      ratingResponse: {
        data: null,
        message: null
      },
      tenantType: null,
      page: 1,
      totalPages: 0,
      limit: 20,
      creditReportPrompt: false,
      balanceUploadPrompt: false,
    }
  },
  beforeMount() {
    this.load()
    this.loadCreditReportTable(false)
  },
  mounted() {
    // Executa a função a cada 5 segundos
    this.loadCreditReportTable(); // Executa a primeira vez ao montar o componente
    this.intervalId = setInterval(() => {
      this.loadCreditReportTable(true);
    }, 5000);
  },
  beforeDestroy() {
    // Limpa o intervalo ao destruir o componente
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    load() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/company/`,
        {
          params: {
            guid: this.guid
          }
        })
        .then((response) => {
          this.company = response.data
          if (this.company != null && this.company.sector != null) {
            this.sector = this.company.sector
          }
        })
      axios.get(`${process.env.VUE_APP_API}/api/v1/company-balance-table/${this.guid}`)
        .then((response) => {
          const balanceObj = Object.entries(response.data.columns)
          this.balanceTable = []

          for (let i = 0; i < balanceObj.length; i++) {
            const line = []
            //Title
            line.push(balanceObj[i][0])
            //Values
            for (let j = 1; j < balanceObj[i].length; j++) {
              const values = balanceObj[i][j]
              for (let z = 0; z < values.length; z++) {
                line.push(values[z])
              }
            }
            this.balanceTable.push(line)
          }

        })

      axios.get(`${process.env.VUE_APP_API}/api/v1/company-balance/${this.guid}`)
        .then((response) => {
          this.balances = response.data
        })
    },

    createCreditReport() {
      let formData = new FormData()
      if (this.file != null) {
        formData.append('file', this.file);
      }
      if (this.registrationFile) {
        formData.append('registrationFile', this.registrationFile);
      }
      if (this.affiliatedCompaniesFile) {
        formData.append('affiliatedCompaniesFile', this.affiliatedCompaniesFile);
      }

      axios.post(`${process.env.VUE_APP_API}/api/v1/finance/credit-report/${this.guid}`, formData)
        .finally(() => {
          this.file = ''
          this.registrationFile = ''
          this.affiliatedCompaniesFile = ''
          this.fileIsValid = false
          this.registrationFileIsValid = false
          this.affiliatedCompaniesFileIsValid = false
          this.loadCreditReportTable()
        })
    },

    loadCreditReportTable(update) {
      // Verifica se há relatórios em andamento
      const hasPendingReports =
        this.creditReports
          .some((report) =>
            report.status !== 'DONE' && report.status !== 'ERROR'
          );

      if (!hasPendingReports && update) {
        return; // Sai do método se houver relatórios pendentes
      }

      // Faz a requisição se não houver relatórios pendentes
      axios
        .get(`${process.env.VUE_APP_API}/api/v1/finance/credit-report`, {
          params: {
            page: this.page - 1,
            limit: this.limit,
            companyGuid: this.guid,
          },
        })
        .then((response) => {
          this.creditReports = response.data.content; // Atualiza a lista de relatórios
          this.totalPages = response.data.totalPages;
        })
    },

    downloadReport(reportGuid) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/finance/credit-report/${reportGuid}`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },

    handleFileUpload(event) {
      const selectedFile = event.target.files[0];

      // Verifica se o arquivo é um PDF
      if (selectedFile && selectedFile.type === 'application/pdf') {
        this.file = selectedFile;
        this.fileIsValid = true;
      } else {
        this.file = null;
        this.fileIsValid = false;
        this.$vs.notify({
          title: 'Erro',
          text: 'Apenas arquivos PDF são permitidos.',
          color: 'danger'
        });
      }
    },

    handleRegistrationFileUpload(event) {
      const selectedFile = event.target.files[0];

      if (selectedFile && selectedFile.name.endsWith('.txt')) {
        this.registrationFile = selectedFile;
        this.registrationFileIsValid = true;
      } else {
        this.registrationFile = null;
        this.registrationFileIsValid = false;
        this.$vs.notify({
          title: 'Erro',
          text: 'Apenas arquivos TXT são permitidos.',
          color: 'danger'
        });
      }
    },

    handleAffiliatedCompaniesFileUpload(event) {
      const selectedFile = event.target.files[0];

      if (selectedFile && selectedFile.name.endsWith('.txt')) {
        this.affiliatedCompaniesFile = selectedFile;
        this.affiliatedCompaniesFileIsValid = true;
      } else {
        this.affiliatedCompaniesFile = null;
        this.affiliatedCompaniesFileIsValid = false;
        this.$vs.notify({
          title: 'Erro',
          text: 'Apenas arquivos TXT são permitidos.',
          color: 'danger'
        });
      }
    },

    handleBalanceFileUpload(event) {
      const selectedFile = event.target.files[0];

      // Verifica se o arquivo é um PDF
      if (selectedFile && (selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || selectedFile.type === 'application/vnd.ms-excel.sheet.macroEnabled.12')) {
        this.balanceFile = selectedFile;
        this.balanceFileIsValid = true;
      } else {
        this.balanceFile = null;
        this.balanceFileIsValid = false;
        this.$vs.notify({
          title: 'Erro',
          text: 'Apenas arquivos XLSX são permitidos.',
          color: 'danger'
        });
      }
    },

    rating(selectedBalance) {
      axios.get(`${process.env.VUE_APP_API}/api/v1/rating`,
        {
          params: {
            company: this.company.guid,
            date: selectedBalance.date
          }
        })
        .then((response) => {
          this.ratingResponse = response
        })
    },

    balanceUpload() {
      const formData = new FormData()
      formData.append('file', this.balanceFile)

      axios.post(`${process.env.VUE_APP_API}/api/v1/balance/${this.company.guid}/${this.overwrite}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(() => {

          this.$vs.notify({
            color: 'success',
            text: 'Balanço cadastrado.'
          })
          this.$router.push({path: `/balanco/${this.guid}`})

        })
        .finally(() => {
          this.file = ''
          this.load()
        })
    },

    openPrompt() {
      this.creditReportPrompt = !this.creditReportPrompt;
    },

    openBalancePrompt() {
      this.balanceUploadPrompt = !this.balanceUploadPrompt;
    }

  }
}
</script>

<style scoped>
/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
.vue-json-scrollable {
  border: 2px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  max-height: 500px; /* Ajuste a altura máxima conforme necessário */
  //max-width: 1000px; /* Ajuste a altura máxima conforme necessário */
  overflow: auto; /* Exibe a barra de rolagem quando necessário */
}
</style>
